import RestService from './RestService';

export default class AttributionService extends RestService {
  constructor() {
    super('attribution');
  }

  /** Recent feasibility checks (history table), newest first; optional customer filter */
  listFeasibility(customerId) {
    const query = customerId ? `?customerId=${customerId}` : '';
    return this.executeGet(this.baseUrl + `/v3/admin/attribution/feasibility${query}`);
  }

  /** Queue a feasibility check: { studyId } or { campaignIds, placeIds | pixelIds }; resolves { requestId, status } */
  startFeasibility(body) {
    return this.post(this.baseUrl + '/v3/admin/attribution/feasibility', body);
  }

  /** Poll a feasibility check; resolves { status, result, errorMessage, ... } */
  getFeasibility(requestId) {
    return this.executeGet(this.baseUrl + `/v3/admin/attribution/feasibility/${requestId}`);
  }

  /** A customer's places, for the feasibility place picker */
  getFeasibilityPlaces(customerId) {
    return this.executeGet(this.baseUrl + `/v3/admin/attribution/feasibility/places?customerId=${customerId}`);
  }

  getFeasibilityPixels(customerId) {
    return this.executeGet(this.baseUrl + `/v3/admin/attribution/feasibility/pixels?customerId=${customerId}`);
  }

  getAvailableCuts() {
    const url = this.baseUrl + '/v3/api/attribution/cut-options';
    return this.executeGet(url);
  }

  runStudy(studyId, startDate, endDate, runBy) {
    let url =
      this.baseUrl + `/v3/api/attribution/process-study/${studyId}`;
    const body = {
      startDate: startDate,
      endDate: endDate,
      runBy: runBy
    };
    return this.post(url, body);
  }

  update(studyId, body) {
    const url = this.baseUrl + `/v3/api/attribution/${studyId}`;
    return super.update(studyId, body, url);
  }

  updateStatus(status, studyId) {
    const url = this.baseUrl + `/v3/api/attribution/status/${studyId}`;
    return this.put(url, { status });
  }

  updateAttributionStudyCuts(studyId, customerId, cuts) {
    if (!studyId || !customerId || !cuts) {
      return;
    }
    const url = this.baseUrl + `/v3/api/attribution/${studyId}/cuts?customerId=${customerId}`;
    return this.put(url, cuts);
  }

  listAttributionStudyCuts(studyId, customerId) {
    if (!studyId || !customerId) {
      return;
    }

    const url = this.baseUrl + `/v3/api/attribution/${studyId}/cuts?customerId=${customerId}`;
    return this.executeGet(url); 
  }
}

